import { useState, useEffect, useMemo, Fragment } from "react";

import Table from "../components/Table/Table";
import Filters from "../components/Filters/Filters";
import axios from "axios";
import { useFilters } from "../Context/FiltersContext";
import { Headers } from "../components/Filters/Utils";
import getFormattedIssuesData from "../components/Filters/Helper/getFilters";
import { INVOKE_URL } from "../constants/api";

const MainPage = () => {
  const { projectKey, fixVersion, issueStatus } = useFilters();

  const [getData, setGetData] = useState([]);

  const projectKeySS = JSON.parse(sessionStorage.getItem("projectKey"));
  const versionSS = JSON.parse(sessionStorage.getItem("fixVersion"));
  const issueStatusSS = JSON.parse(sessionStorage.getItem("issueStatus"));

  const URL = `${INVOKE_URL}/allfilters?projectKey=${projectKeySS}&version=${versionSS}&ticketStatus=${JSON.stringify(issueStatusSS).replace(
    /[[\]']+/g,
    ""
  )}`;
  const dataResponse = useMemo(() => getFormattedIssuesData(getData), [getData]);

  // const devURL = `/multiSelect/allFilters/${projectKeySessionStorageItems}/${versionSessionStorageItem}/${JSON.stringify(
  //   issueStatusSessionStorageItem
  // ).replace(/[\[\]']+/g, "")}`;

  useEffect(() => {
    const abortController = new AbortController();
    const fetchFilters = async () => {
      try {
        if (projectKeySS?.length && versionSS?.length && issueStatusSS?.length) {
          // const res = await axios.get(devURL, { signal }); // Dev environment only for testing.
          const res = await axios.get(URL, { Headers, signal: abortController.signal });
          setGetData(res.data.issues);
          descriptionName();
        }
      } catch (err) {
        if (err.name === "AbortError") {
          console.error(err.name);
          return err.name;
        }
        console.error(err);
        throw err;
      }
    };
    fetchFilters();

    return () => {
      abortController.abort();
    };
  }, [projectKey, fixVersion, issueStatus]);

  // Storing the fixVersion description so it can be used in the preview format page.
  const getFixVersionDescription = () => getData.map((item) => item.fields.fixVersions[0]?.description);
  const descriptionName = () => {
    const rmDuplicateName = [...new Set(getFixVersionDescription())];
    localStorage.setItem("version-description", rmDuplicateName ?? "");
  };

  return (
    <Fragment>
      <Filters />
      {issueStatusSS?.length > 0 ? <Table rows={dataResponse} getData={getData} /> : null}
    </Fragment>
  );
};

export default MainPage;
